// TagSelector.jsx
import React, { useEffect, useState } from 'react';
import { Form } from 'antd';

const TagSelector = ({ onChange, defaultValue, reset, setReset }) => {
  const [selectedTags, setSelectedTags] = useState(defaultValue || []);

  const tags = [
    'Religious', 'Social', 'Professional', 'Charity', 'Activism', 'Sports', 'Art',
    'Volunteer', 'Family', 'Education', 'Wellness', 'Revert', 'Travel', 'Virtual'
  ];

  const toggleTag = (tag) => {
    const newSelectedTags = selectedTags.includes(tag)
      ? selectedTags.filter(t => t !== tag)
      : [...selectedTags, tag];

    setSelectedTags(newSelectedTags);
    if (onChange) {
      onChange(newSelectedTags);
    }
    if (setReset) setReset(false);
  };

  useEffect(() => {
    if (reset) {
      setSelectedTags([]);
    }
  }, [reset]);

  return (
    <div className="tag-selector-container">
      <Form.Item label="Select Tags (optional)" className="tag-selector-title">
        <div className="tags-container">
          {tags.map(tag => (
            <div
              key={tag}
              onClick={() => toggleTag(tag)}
              className={`tag-option ${selectedTags.includes(tag) ? 'selected' : ''}`}
            >
              {tag}
            </div>
          ))}
        </div>
      </Form.Item>
    </div>
  );
};

export default TagSelector;